import React from 'react';
import {
  Tooltip,
  ClickAwayListener,
  makeStyles,
  Theme,
  Grid,
  Typography,
} from '@material-ui/core';
import { colors } from 'design-system';
import { LightIcon } from '../../Icons';

type Props = {
  title: string;
  children: React.ReactElement;
};

const useStyles = makeStyles((theme: Theme) => ({
  background: {
    backgroundColor: `${colors.cloud} !important`,
    padding: 10,
    maxWidth: '320px !important',
    boxShadow: '0px 5px 5px rgba(0, 0, 0, 0.08)',
  },
  popper: {
    top: '-22px !important',
    left: '-15px !important',
    padding: '5px',
  },
  tittleTooltip: {
    display: 'inline-block',
    width: 'calc(100% - 40px)',
    marginLeft: theme.spacing(1.25),
    color: colors.abbey,
    fontSize: '12px',
    fontStyle: 'normal',
  },
}));

const TooltipCustom = ({ title, children }: Props): JSX.Element => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleOpen = (): void => {
    setOpen(true);
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div>
        <Tooltip
          data-testid="tooltip"
          classes={{
            tooltip: classes.background,
          }}
          PopperProps={{
            disablePortal: true,
            className: classes.popper,
          }}
          onClose={handleClose}
          onClick={handleOpen}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={
            <Grid item xs={12} container alignItems="center">
              <LightIcon />
              <Typography
                align="left"
                variant="caption"
                className={classes.tittleTooltip}
              >
                {title}
              </Typography>
            </Grid>
          }
        >
          {children}
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};

export default TooltipCustom;
